import styled, { css } from 'styled-components';
import Icon from '../../../../icon';
import { generateBoxShadow, pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptModal toggle wrapper
 */
export const receiptmodalToggleWrapperStyles = ({ theme }) => css `
	position: fixed;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['400'])};
	background-color: ${theme.colors.light.bgReceiptPrice};
	box-shadow: ${generateBoxShadow(theme.boxShadow.toast)};
`;
export const StyledReceiptModalToggleWrapper = styled.div `
	${receiptmodalToggleWrapperStyles}
`;
/**
 * ReceiptModal toggle
 */
export const receiptmodalToggleStyles = () => css `
	position: absolute;
	inset: 0;
	padding: 0;
	border: none;
	cursor: pointer;
	color: unset;
	background: transparent;

	&:hover,
	&:active,
	&:focus {
		color: unset;
	}
`;
export const StyledReceiptModalToggle = styled.button `
	${receiptmodalToggleStyles}
`;
/**
 * ReceiptModal toggle lip
 */
export const receiptModalToggleLipStyles = ({ theme }) => css `
	position: absolute;
	top: 0;
	right: ${pxToRem(theme.spacing['400'])};
	transform: translateY(-100%);
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['300'])};
	border-top-left-radius: ${pxToRem(theme.borderRadius.s)};
	border-top-right-radius: ${pxToRem(theme.borderRadius.s)};
	background-color: ${theme.colors.light.bgReceiptPrice};
	box-shadow: ${generateBoxShadow(theme.boxShadow.toast)};

	/* hide box shadow spill */
	&::after {
		content: '';
		position: absolute;
		right: -${pxToRem(theme.spacing['200'])};
		bottom: 0;
		left: -${pxToRem(theme.spacing['200'])};
		height: ${pxToRem(theme.spacing['200'])};
		transform: translateY(100%);
		background-color: inherit;
	}
`;
export const StyledReceiptModalToggleLip = styled.div `
	${receiptModalToggleLipStyles}
`;
/**
 * ReceiptModal toggle icon
 */
export const StyledReceiptModalToggleIcon = styled(Icon).attrs({
    variant: 'chevron-up',
    size: 'sm',
}) ``;
